var swiper = new Array();
jQuery(document).ready(function(){
   /* Load filtered products in div */
   if (jQuery('.dynamic-products').length) {
      loadProducts(jQuery('.dynamic-products').attr('data-term_id'));
   };

   jQuery('.booking-popup-trigger').click(function(){
      var url = jQuery(this).attr('data-url');
      launchBookingPopup(url);
   });

   if(jQuery('iframe').length){
     var src = jQuery('iframe').attr('src');
     var docWidth = jQuery(window).width() - 48;
     var newSrc = src.replaceAll('width=500', 'width=' + docWidth);
     jQuery('iframe').attr('src', newSrc);
   }


   jQuery('.swiper-container').each(function(i){
      var $this = jQuery(this);
      swiper['html'+i] = $this.html();
   });

   if(jQuery('.product-photos').length){
      jQuery(".product-photos").colorbox({
         rel:'product-photos',
         transition: 'elastic',
         width:"85%",
         height:"75%",
         returnFocus: false,
         closeButton: false,
         overlayClose: false,
         onOpen: function(){
            jQuery('body').css({'overflow' : 'hidden'});
            jQuery('.colorbox-close, .colorbox-controls').addClass('active');
         },
         onCleanup: function(){
            jQuery('body').removeAttr('style');
            jQuery('.colorbox-close, .colorbox-controls').removeClass('active');
         }
      });
   }

   jQuery('.colorbox-controls').click(function(){
      var $this = jQuery(this);
      if($this.hasClass('next')){
         jQuery.colorbox.next();
      }
      else if($this.hasClass('previous')){
         jQuery.colorbox.prev();
      }
   });

   jQuery('.colorbox-close').click(function(){
      jQuery.colorbox.close();
   });

   /* only show slider on smaller devices */
   initSwiper();
});

window.addEventListener("orientationchange", function() {
   if(!jQuery('header').hasClass('quotation-header')){
      /* Wait for orientation to finish before re-initing swiper */
      setTimeout(function(){
         initSwiper();
      }, 400);
   }
});

/* init swiper, vw = window width in pixels */

function initSwiper(){
   var vw = jQuery(window).width();
   if(vw < 851){
      var slidesPerView = 2.25;
      var spaceBetween = 24;
      if (vw < 500){
         slidesPerView = 1.25;
         spaceBetween = 12;
      }
      jQuery('.swiper-container').each(function(i){

         var $this = jQuery(this);
        //  if ($this.hasClass('swiper-link-bar')){
        //     if($this[0].swiper){
        //        $this[0].swiper.destroy();
        //        $this.html(swiper['html'+i]);
        //     }
        //     swiper[i] = new Swiper($this, {
        //        slidesPerView: 'auto',
        //        freeMode: true,
        //        loop: false,
        //        navigation: {
        //           nextEl: '.swiper-button-next',
        //           prevEl: '.swiper-button-prev',
        //        },
        //     });
        //  }

         if ($this.hasClass('swiper-link-blocks')){
            if($this[0].swiper){
               $this[0].swiper.destroy();
               $this.html(swiper['html'+i]);
            }
            swiper[i] = new Swiper($this, {
               slidesPerView: 'auto',
               freeMode: true,
               loop: false,
               navigation: {
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev',
               },
            });
         }
         else if(!$this.hasClass('products-container--double-column') && !$this.hasClass('added-products')){
            if($this[0].swiper){
               $this[0].swiper.destroy();
               $this.html(swiper['html'+i]);
            }
            swiper[i] = new Swiper($this, {
               slidesPerView: slidesPerView,
               spaceBetween: spaceBetween,
               loop: false,
               navigation: {
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev',
               },
            });
         }
      });
   }else{
      jQuery('.swiper-container').each(function(i){
         var $this = jQuery(this);
         if($this[0].swiper){
            $this[0].swiper.destroy();
            swiper[i] = undefined;
            setTimeout(function(){
               $this.html(swiper['html'+i]);
            }, 250);
         }
      });
   }
}

function loadProducts(termId) {
   var data = {
      'action': 'get_products',
      'term_id': termId
   };

   jQuery.post(wpdata.ajax_url, data, function (response) {
      if (response) {
         jQuery('.dynamic-products').append(response);
         jQuery('.dynamic-products').addClass('loaded');
         jQuery('.reset-filters').click(function() {
           Cookies.remove('quotation_date');
           Cookies.remove('quotation_group_size');
           document.location.reload();
         });
         jQuery('.swiper-container').each(function(i){
            var $this = jQuery(this);
            swiper['html'+i] = $this.html();
         });
         initSwiper();
      }
   });
}

function launchBookingPopup(url) {
   var scrollHeight;
   var $popup = jQuery('div[data-type=booking-module]');
   $popup.css('display', 'flex');
   $popup.find('.form-container').css('display', 'block');
   $popup.addClass('open'); 
   $popup.find('iframe').attr('src', url);
   scrollHeight = jQuery('.form-popup.open .form-container-with-scrollbar .booking-module').height() - jQuery('.form-popup.open .form-container-with-scrollbar').height();
   setTimeout(function () {
      $popup.addClass('active');
      if (scrollHeight < 1) {
         jQuery('.form-popup.active .fake-scrollbar').css('opacity', '0');
         $popup.find('.form-container').css({'min-height': jQuery('.form-popup.active .form-container-with-scrollbar').height() + 'px', 'height': (jQuery('.form-popup.active .form-container-with-scrollbar').height() + 124) + 'px'});
      }
   }, 10);
   disableScroll();
   return scrollHeight;
}
